/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RouterModule } from '@angular/router';
import { CartCouponModule } from '@spartacus/cart/base/components';
import { AddToCartModule } from '@spartacus/cart/base/components/add-to-cart';
import { FeaturesConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import {
  AtMessageModule,
  IconModule,
  MediaModule,
  OutletModule,
  PromotionsModule,
  SpinnerModule,
} from '@spartacus/storefront';
import { Udxb2bMaterialModule } from '../../udxb2b-material.module';
import { Ubxb2bCartItemValidationWarningModule } from '../../validation/cart-item-validation-warning/cart-item-validation-warning.module';
import { Udxb2bItemCounterModule } from '../item-counter';
import { UdxCartItemComponent } from './cart-item';
import { UdxCartItemListRowComponent } from './cart-item-list-row';
import { UdxCartItemListComponent } from './cart-item-list/cart-item-list.component';
import { OrderSummaryComponent } from './order-summary/order-summary.component';
import { UdxModifyOrderCartItemListComponent } from './cart-item-list/modify-order-cart-item-list.component';
import { DayjsFormatModule } from "../../utilities/date/dayjs-format.module";

@NgModule({
    imports: [
        AtMessageModule,
        CartCouponModule,
        CommonModule,
        FeaturesConfigModule,
        I18nModule,
        IconModule,
        MediaModule,
        OutletModule,
        PromotionsModule,
        ReactiveFormsModule,
        RouterModule,
        UrlModule,
        AddToCartModule,
        Udxb2bItemCounterModule,
        Ubxb2bCartItemValidationWarningModule,
        Udxb2bMaterialModule,
        MatDatepickerModule,
        MatNativeDateModule,
        SpinnerModule,
        FormsModule,
        DayjsFormatModule,
        UdxCartItemComponent, OrderSummaryComponent, UdxCartItemListComponent, UdxCartItemListRowComponent, UdxModifyOrderCartItemListComponent
    ],
    providers: [],
    exports: [UdxCartItemComponent, UdxCartItemListRowComponent, UdxCartItemListComponent, OrderSummaryComponent, UdxModifyOrderCartItemListComponent],
})
export class UdxB2bCartSharedModule {}
